import { Component } from '@angular/core';
import { OnboardingService } from '../../../../core/services/api/onboarding.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'ling-tour-button',
  templateUrl: './tour-button.component.html',
  styleUrls: ['./tour-button.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, MatButtonModule],
})
export class TourButtonComponent {
  constructor(public onboardingService: OnboardingService) {}
}
